import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { HeadTags } from '@grandvisionhq/content';
import { useFeatureToggles } from '@grandvisionhq/state';
import { useMeta } from '../../context/MetaContext.js';

function rewriteCanonical(canonicalUrl, selfUrl, pageNr) {
    // Strip scheme and host from url and save just the pathname parts
    const [, , , ...path] = canonicalUrl.split('/');
    const pageParameter = pageNr && pageNr !== 1 ? `?page=${pageNr}` : '';
    return `${selfUrl}/${path.join('/')}${pageParameter}`;
}
function createHreflangLink(hreflang, selfUrl) {
    const absoluteUrlPattern = /^https?:\/\/|^\/\//i;
    const url = absoluteUrlPattern.test(hreflang.url) ? hreflang.url : `${selfUrl || ''}${hreflang.url}`;
    const locale = hreflang.locale.replace('_', '-').toLowerCase();
    return {
        url,
        locale
    };
}
const CmsHeadTags = ({ title , description , ogUrl , ogImage , hreflangs , noIndex , noFollow , pageNr , children ,  })=>{
    const { featureConfigs  } = useFeatureToggles();
    const { ogSiteName  } = featureConfigs;
    const { site , selfUrl , headComponent  } = useMeta();
    const siteName = site.name || '';
    const props = {
        title: title ? `${title} | ${siteName}` : siteName,
        description: description || site.description || '',
        ogSiteName,
        ogImage: ogImage || site.ogImage || '',
        ogUrl: rewriteCanonical(ogUrl || site.url || '', selfUrl, pageNr),
        hreflangs: Array.isArray(hreflangs) && hreflangs.length > 1 ? hreflangs.map((entry)=>createHreflangLink(entry, selfUrl)
        ) : [],
        headComponent,
        noIndex,
        noFollow,
        children
    };
    return /*#__PURE__*/ React.createElement(HeadTags, swcHelpers.extends({}, props));
};

export { CmsHeadTags as default };
//# sourceMappingURL=HeadTags.js.map
